import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  VEHICLES,
  CONTRACTS,
  MODEL_LIST,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Vehicles",
    meta: { requiresAuth: true },
    redirect: { name: "VehiclesDashboard" },
    component: () => import("@/modules/Vehicles/Vehicles"),
    children: [
      // DASHBOARD
      {
        path: "home",
        name: "VehiclesDashboard",
        component: () => import("@/modules/Vehicles/Pages/Index.vue"),
        meta: {
          code: MODULE.VEHICLES.DASHBOARD,
        },
      },
      // MAP
      {
        path: "map/:owner?/:vehicle?",
        name: "VehiclesMap",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleMap.vue"),
        meta: {
          code: MODULE.VEHICLES.MAP,
        },
      },
      // VEHICLES
      {
        path: "vehicles",
        name: "VehicleList",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleList.vue"),
        meta: {
          breadcrumb: [{ name: "common.vehicles", link: VEHICLES }],
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/form",
        name: "Vehicles Owners",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleOwners.vue"),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/form/types/:ownerId",
        name: "Vehicles PageForm",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleTypes.vue"),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/form/:ownerId/:type",
        name: "Vehicles CreationOptions",
        component: () =>
          import(
            "@/modules/Vehicles/Pages/Vehicles/VehicleCreationOptions.vue"
          ),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/form/:ownerId/:type/:creation",
        name: "Vehicles Type",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleBrands.vue"),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      // {
      //   path: "vehicles/form/:ownerId/:type/:creation/:brand",
      //   name: "Vehicles Brands",
      //   component: () =>
      //     import("@/modules/Vehicles/Pages/Vehicles/VehicleModels.vue"),
      //   meta: {
      //     code: MODULE.VEHICLES.VEHICLES,
      //   },
      // },
      {
        path: "vehicles/form/:ownerId/:type/:creation/:brand/:model",
        name: "Vehicles Form",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleForm.vue"),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/form/:ownerId/:type/:creation/newVehicle",
        name: "Vehicles Form New",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleForm.vue"),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      {
        path: "vehicles/detail/:id",
        name: "Vehicle Details",
        component: () =>
          import(
            "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailWrapper.vue"
          ),
        meta: {
          code: MODULE.VEHICLES.VEHICLES,
        },
        children: [
          {
            path: "main",
            name: "Vehicle Details Main",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailInformation.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
          {
            path: "notes",
            name: "Vehicle Details Notes",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailNotes.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
          {
            path: "synchronization",
            name: "Vehicle Details Synchronization",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailSynchronization.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
          {
            path: "damage",
            name: "Vehicle Details Damage",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailDamage.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
          {
            path: "calendar",
            name: "Vehicle Details Calendar",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailCalendar.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
          {
            path: "bookings/:subpageId?",
            name: "Vehicle Details Bookings",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleDetailTimeline.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.VEHICLES,
            },
          },
        ],
      },
      //transfer
      {
        path: "vehicles/transfer/:vehicleId",
        name: "Vehicle transfer",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleTransfer"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.VEHICLES,
        },
      },
      // RENTALS
      {
        path: "contracts",
        name: "VehiclesTravelList",
        component: () =>
          import("@/modules/Vehicles/Pages/Travels/TravelsList.vue"),
        meta: {
          breadcrumb: [{ name: "common.vehicles", link: CONTRACTS }],
          code: MODULE.VEHICLES.RENTALS,
        },
      },
      {
        path: "contracts/detail/:id",
        name: "TravelDetail",
        component: () =>
          import("@/modules/Vehicles/Pages/Travels/TravelDetailWrapper"),
        meta: {
          code: MODULE.VEHICLES.RENTALS,
        },
        children: [
          {
            path: "information",
            name: "TravelDetailInformation",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Travels/TravelDetailInformation"
              ),
            meta: {
              code: MODULE.VEHICLES.RENTALS,
            },
          },
          {
            path: "services",
            name: "TravelDetailServices",
            component: () =>
              import("@/modules/Vehicles/Pages/Travels/TravelDetailServices"),
            meta: {
              code: MODULE.VEHICLES.RENTALS,
            },
          },
          {
            path: "log",
            name: "TravelDetailLog",
            component: () =>
              import("@/modules/Vehicles/Pages/Travels/TravelDetailLog"),
            meta: {
              code: MODULE.VEHICLES.RENTALS,
            },
          },
          {
            path: "support",
            name: "TravelDetailSupport",
            component: () =>
              import("@/modules/Vehicles/Pages/Travels/TravelDetailSupport"),
            meta: {
              code: MODULE.VEHICLES.RENTALS,
            },
          },
          {
            path: "notes",
            name: "TravelDetailNotes",
            component: () =>
              import("@/modules/Vehicles/Pages/Travels/TravelDetailNotes"),
            meta: {
              code: MODULE.VEHICLES.RENTALS,
            },
          },
        ],
      },
      // BOOKINGS
      {
        path: "bookings",
        name: "Vehicles Bookings Tabs",
        component: () =>
          import("@/modules/Vehicles/Pages/Bookings/VehiclesBookings.vue"),
        meta: {
          code: MODULE.VEHICLES.BOOKINGS,
        },
        children: [
          {
            path: "deliveries",
            name: "Vehicles Bookings Deliveries",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Bookings/VehiclesBookingsDeliveries.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.BOOKINGS,
            },
          },
          {
            path: "returns",
            name: "Vehicles Bookings Returns",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Bookings/VehiclesBookingsReturns.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.BOOKINGS,
            },
          },
          {
            path: "operations",
            name: "Vehicles Bookings Operations",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Bookings/VehiclesBookingsOperations.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.BOOKINGS,
            },
          },
        ],
      },
      {
        path: "timeline",
        name: "Vehicles Bookings",
        component: () =>
          import("@/modules/Vehicles/Pages/Timeline/VehiclesTimeline.vue"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BOOKINGS,
        },
      },
      {
        path: "bookings/checkin/:type",
        name: "Booking checkin",
        component: () =>
          import("@/modules/Vehicles/Pages/Bookings/VehiclesBookingsCheckin"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BOOKINGS,
        },
      },
      {
        path: "bookings/form",
        name: "Booking form",
        component: () =>
          import("@/modules/Vehicles/Pages/Bookings/VehiclesBookingsForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BOOKINGS,
        },
      },
      {
        path: "bookings/operation/processing/vehicle/:vehicleId/operation/:operationId",
        name: "Booking operation process",
        component: () =>
          import(
            "@/modules/Vehicles/Components/Bookings/OperationProcessingDetail.vue"
          ),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BOOKINGS,
        },
      },
      // MODELS
      {
        path: "models",
        name: "Vehicles Model List",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleModelList.vue"),
        meta: {
          breadcrumb: [{ name: "common.models", link: MODEL_LIST }],
          code: MODULE.VEHICLES.MODELS,
        },
      },
      {
        path: "models/form",
        name: "Vehicles Model PageForm",
        component: () =>
          import("@/modules/Vehicles/Pages/Vehicles/VehicleModelForm.vue"),
        meta: {
          code: MODULE.VEHICLES.MODELS,
        },
      },
      {
        path: "models/detail/:code",
        name: "Vehicle Model Details",
        component: () =>
          import(
            "@/modules/Vehicles/Pages/Vehicles/Detail/VehicleModelDetail.vue"
          ),
        meta: {
          code: MODULE.VEHICLES.MODELS,
        },
      },
      // CATEGORIES
      {
        path: "category/detail/:id?",
        name: "Category Detail",
        component: () =>
          import("@/modules/Vehicles/Pages/Categories/CategoryDetailWrapper"),
        meta: {
          code: MODULE.VEHICLES.CATEGORIES,
        },
        children: [
          {
            path: "vehicles",
            name: "CategoryDetailVehicles",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailVehicles.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "branches",
            name: "CategoryDetailBranches",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailBranches.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "pricings",
            name: "CategoryDetailPricings",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailPricings.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "extras",
            name: "CategoryDetailExtras",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailExtras.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "legal",
            name: "CategoryDetaiLegal",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailLegal.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "main",
            name: "CategoryDetailMain",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailMainInfo.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
          {
            path: "images",
            name: "CategoryDetailImages",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Categories/CategoryDetailImages.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.CATEGORIES,
            },
          },
        ],
      },
      {
        path: "category",
        name: "Category List",
        component: () =>
          import("@/modules/Vehicles/Pages/Categories/CategoryList"),
        meta: {
          code: MODULE.VEHICLES.CATEGORIES,
        },
      },
      {
        path: "category/form",
        name: "Category Form",
        component: () =>
          import("@/modules/Vehicles/Pages/Categories/CategoryForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.CATEGORIES,
        },
      },
      // SUBSCRIPTIONS
      {
        path: "subscriptions",
        name: "Vehicle Subscriptions Tabs",
        component: () =>
          import(
            "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptions.vue"
          ),
        meta: {
          code: MODULE.VEHICLES.SUBSCRIPTIONS,
        },
        redirect: { name: "Vehicles Subscriptions Deliveries" },
        children: [
          {
            path: "requests",
            name: "Vehicles Bookings Requests",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptionsRequests.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.BOOKINGS,
            },
          },
          {
            path: "deliveries",
            name: "Vehicles Subscriptions Deliveries",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptionsDeliveries.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.SUBSCRIPTIONS,
            },
          },
          {
            path: "returns",
            name: "Vehicles Subscriptions Returns",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptionsReturns.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.SUBSCRIPTIONS,
            },
          },
          {
            path: "expired",
            name: "Vehicles Subscriptions Expired",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptionsExpired.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.SUBSCRIPTIONS,
            },
          },
          {
            path: "exceeded",
            name: "Vehicles Subscriptions Exceeded",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Subscriptions/VehiclesSubscriptionsExceeded.vue"
              ),
            meta: {
              code: MODULE.VEHICLES.SUBSCRIPTIONS,
            },
          },
        ],
      },
      {
        path: "subscription/form",
        name: "Subscription Form",
        component: () =>
          import("@/modules/Vehicles/Pages/Subscriptions/SubscriptionForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.SUBSCRIPTIONS,
        },
      },
      // budgets
      {
        path: "budgets",
        name: "Budgets List",
        component: () => import("@/modules/Vehicles/Pages/Budgets/BudgetsList"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BUDGETS,
        },
      },
      {
        path: "budgets/form",
        name: "Budgets Types",
        component: () => import("@/modules/Vehicles/Pages/Budgets/BudgetTypes"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BUDGETS,
        },
      },
      {
        path: "budgets/form/:type",
        name: "Budgets Form",
        component: () => import("@/modules/Vehicles/Pages/Budgets/BudgetForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BUDGETS,
        },
      },
      {
        path: "budgets/detail/:budgetId",
        name: "Budgets Detail",
        component: () =>
          import("@/modules/Vehicles/Pages/Budgets/BudgetDetail"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.BUDGETS,
        },
      },
      // seasons
      {
        path: "seasons",
        name: "Seasons List",
        component: () => import("@/modules/Vehicles/Pages/Seasons/SeasonsList"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.SEASONS,
        },
      },
      {
        path: "seasons/form",
        name: "Seasons Form",
        component: () => import("@/modules/Vehicles/Pages/Seasons/SeasonForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.SEASONS,
        },
      },
      {
        path: "seasons/detail/:seasonId",
        name: "Seasons Detail",
        component: () =>
          import("@/modules/Vehicles/Pages/Seasons/SeasonDetail"),
        redirect: { name: "Seasons Detail Configuration" },
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.SEASONS,
        },
        children: [
          {
            path: "configuration",
            name: "Seasons Detail Configuration",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/Seasons/SeasonDetailConfiguration"
              ),
            meta: {
              code: MODULE.VEHICLES.SEASONS,
            },
          },
          {
            path: "pricings",
            name: "Seasons Detail Pricings",
            component: () =>
              import("@/modules/Vehicles/Pages/Seasons/SeasonDetailPricings"),
            meta: {
              code: MODULE.VEHICLES.SEASONS,
            },
          },
        ],
      },
      // group of seats
      {
        path: "groupSeats",
        name: "Group Seats List",
        component: () =>
          import("@/modules/Vehicles/Pages/GroupSeats/GroupSeatsList"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.GROUP_SEATS,
        },
      },
      {
        path: "groupSeats/form",
        name: "Group Seats Form",
        component: () =>
          import("@/modules/Vehicles/Pages/GroupSeats/GroupSeatsForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.GROUP_SEATS,
        },
      },
      {
        path: "groupSeats/detail/:groupSeatsId",
        name: "Group Seats Detail",
        component: () =>
          import("@/modules/Vehicles/Pages/GroupSeats/GroupSeatsDetailWrapper"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.GROUP_SEATS,
        },
        redirect: { name: "Group Seats Detail Details" },
        children: [
          {
            path: "details",
            name: "Group Seats Detail Details",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/GroupSeats/GroupSeatsDetailDetails"
              ),
            meta: {
              code: MODULE.VEHICLES.GROUP_SEATS,
            },
          },
          {
            path: "associations",
            name: "Group Seats Detail Associations",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/GroupSeats/GroupSeatsDetailAssociations"
              ),
            meta: {
              code: MODULE.VEHICLES.GROUP_SEATS,
            },
          },
          {
            path: "occupation",
            name: "Group Seats Detail Occupation",
            component: () =>
              import(
                "@/modules/Vehicles/Pages/GroupSeats/GroupSeatsDetailOccupation"
              ),
            meta: {
              code: MODULE.VEHICLES.GROUP_SEATS,
            },
          },
        ],
      },
      // expenses
      {
        path: "expenses",
        name: "Expenses List",
        component: () =>
          import("@/modules/Vehicles/Pages/Expenses/ExpensesVehicleList"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.EXPENSES,
        },
      },
      {
        path: "expenses/detail/:vehicleId",
        name: "Expenses Detail",
        component: () =>
          import("@/modules/Vehicles/Pages/Expenses/ExpensesVehicleDetail"),
        meta: {
          breadcrumb: [],
          code: MODULE.VEHICLES.EXPENSES,
        },
      },
    ],
  },
];
